module.exports = __webpack_public_path__ + "static/img/b-icon-2-active.99df574.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/en/b-icon-2-active.png
// module id = ufOZ
// module chunks = 0